import React from "react";

export function PageHeader({ kicker, title, sub, right }) {
  return (
    <div className="max-w-[1600px] mx-auto px-4 sm:px-6 pt-12 pb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div>
        {kicker && (
          <div className="font-mono-label text-[11px] text-[var(--accent)] mb-3">
            {kicker}
          </div>
        )}
        <h1 className="font-display text-5xl sm:text-6xl md:text-7xl uppercase leading-[0.92]">
          {title}
        </h1>
        {sub && <p className="text-neutral-400 mt-4 max-w-xl">{sub}</p>}
      </div>
      {right}
    </div>
  );
}

export function SectionTitle({ label, children, action }) {
  return (
    <div className="flex items-end justify-between mb-6">
      <div>
        {label && (
          <div className="font-mono-label text-[10px] text-[var(--accent)] mb-2">
            {label}
          </div>
        )}
        <h2 className="font-headline text-2xl md:text-3xl uppercase">
          {children}
        </h2>
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ children }) {
  return (
    <div className="border border-dashed border-neutral-800 p-12 text-center font-mono-label text-xs text-neutral-500">
      {children || "Nothing here yet."}
    </div>
  );
}
